export const DEFAULT_SYSTEM_PROMPT =
    "The following is a friendly conversation between a human and an AI. The AI is talkative and provides lots of specific details from its context. If the AI does not know the answer to a question, it truthfully says it does not know.";

export const CHAT_FILES_MAX_SIZE =
    parseInt(process.env.NEXT_PUBLIC_CHAT_FILES_MAX_SIZE || '') || 0;

export const NEXT_PUBLIC_CHAT_FILES_UPLOAD_PATH = process.env.NEXT_PUBLIC_CHAT_FILES_UPLOAD_PATH || "public/uploads";

// export const SUPABASE_KEY = process.env.SUPABASE_SERVICE_ROLE_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZsanhnd2xrYnVldXp0bm1icmRoIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTY5MzU4ODE2MiwiZXhwIjoyMDA5MTY0MTYyfQ.XcihonZlE_9zDeV6IOlabYV_G855WPJ_Sw7f5KAMYXE"
// if (!SUPABASE_KEY) throw new Error(`Expected SUPABASE_SERVICE_ROLE_KEY`)

// export const SUPABASE_URL = process.env.SUPABASE_URL || "https://vljxgwlkbueuztnmbrdh.supabase.co";
// if (!SUPABASE_URL) throw new Error(`Expected env var SUPABASE_URL`)

export const OPENAI_TYPE = process.env.OPENAI_TYPE || "AZURE_OPENAI"; // Or OPENAI || AZURE_OPENAI

export const OPENAI_API_KEY = process.env.OPENAI_API_KEY || "";;
export const OPENAI_API_MODEL = process.env.OPENAI_API_MODEL;

export const AZURE_OPENAI_API_KEY = process.env.AZURE_OPENAI_API_KEY || "";

export const AZURE_OPENAI_API_INSTANCE_NAME = process.env.AZURE_OPENAI_API_INSTANCE_NAME || "tmap-openai";

export const AZURE_OPENAI_API_DEPLOYMENT_NAME = process.env.AZURE_OPENAI_API_DEPLOYMENT_NAME || "GPT432K";
export const AZURE_OPENAI_API_EMBEDDINGS_DEPLOYMENT_NAME = process.env.AZURE_OPENAI_API_EMBEDDINGS_DEPLOYMENT_NAME || "embeddingada002";

export const AZURE_OPENAI_API_VERSION = process.env.AZURE_OPENAI_API_VERSION || "2023-05-15";
export const INDEX_DIR = process.env.INDEX_DIR || "public/index"